import { render, staticRenderFns } from "./TrainingQuiz.vue?vue&type=template&id=5245917d&"
import script from "./TrainingQuiz.vue?vue&type=script&lang=js&"
export * from "./TrainingQuiz.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports